import React, { useEffect, useState } from "react";
import { WidgetComponents } from "../WidgetComponents";
import {
  Stepper,
} from './SliderComponents';
import { useTranslation } from "react-i18next";

import className from "./style.module.scss";

const {
  Slider,
  RangeSlider,
  RangeSliderLabels,
} = WidgetComponents;

export function InputSlider(props) {
  const sceneData = props.sceneData;

  const {
    t,
    // i18n
  } = useTranslation("translation");

  const [ariaInterval, setAriaInterval] = useState(0);
  const [stringParams, setStringParams] = useState({
    "value": props.sceneData.default,
  });

  useEffect(() => {
    sceneData.altTextData.map((interval, index) => {
      if (interval.min <= props.sceneData.default && props.sceneData.default <= interval.max) {
        setAriaInterval(index);
      }
    })
    
    updateStringParams()
  }, [props.sceneData.default])

  const updateStringParams = () => {
    const newStringParams = stringParams;
    newStringParams.value = props.sceneData.default;
    setStringParams({...newStringParams});
  };

  const renderDevFeatures = () => {
    return (
      <div className={className.Debug}>
          <div>
              Alt-text: <br />
              {sceneData.altTextData.length > 0
              ? t(`${sceneData.altTextData[ariaInterval].sliderAltText}.string`, stringParams)
              : ""}
          </div>
          {props.sceneData.recordURL !== undefined ?
              <button onClick={() => { window.open(props.sceneData.recordURL, "_blank") }}>
                  Airtable record
              </button>
          : null}
      </div>
  )
  };

  return (
    <>
      <Slider>
        <RangeSliderLabels
          left={
            sceneData.startLabel === "" ? ""
              : t(`${sceneData.startLabel}.string`)
          }
          middle={
            sceneData.middleLabel === "" ? ""
              : t(`${sceneData.middleLabel}.string`)
          }
          right={
            sceneData.endLabel === "" ? ""
              : t(`${sceneData.endLabel}.string`)
          }
        />
        <RangeSlider
          labelledby={props.labelledby}
          min={sceneData.min}
          max={sceneData.max}
          step={sceneData.step}
          value={props.sceneData.default}
          scaleInterval={sceneData.labelledInterval}
          inputLabel={
            sceneData.altTextData.length > 0
              ? t(`${sceneData.altTextData[ariaInterval].sliderAltText}.string`, stringParams)
              : ""
          }
          keyboardStep={
            sceneData.altTextData.length > 0
              ? sceneData.altTextData[ariaInterval].keyboardStep !== "" && sceneData.mobileControls.preset === "Vague"
                ? "auto"
                : ""
              : ""
          }
          onSliderChange={(value) => { props.updateControl(value) }}
          altTextData={sceneData.altTextData}
          ariaInterval={ariaInterval}
        />
        {props.dev === true ? renderDevFeatures() : null}
        {props.sceneData.mobileControls.preset !== "" ?
          <Stepper
            currentValue={props.sceneData.default}
            onChange={(value) => { props.updateControl(value) }}
            min={sceneData.min}
            max={sceneData.max}
            step={sceneData.step}
            altTextData={sceneData.altTextData}
            ariaInterval={ariaInterval}
            mobileControls={sceneData.mobileControls}
            keyboardStep={
              sceneData.altTextData.length > 0
                ? sceneData.altTextData[ariaInterval].keyboardStep === ""
                  ? ""
                  : "auto"
                : ""
            }
          />
          : null}
      </Slider>
    </>
  );
}
